import React, { useEffect } from "react";
import { animate, useMotionTemplate, useMotionValue, useTransform } from "framer-motion";
import { ChakraText } from "ui/chakra-framer";

const percentageStart = 18;
const percentageEnd = 80;

type PercentageProps = {
  isInView?: boolean;
  animationDuration: number;
  animationDelay: number;
};

export function Percentage({ isInView, animationDuration, animationDelay }: PercentageProps) {
  const motionValue = useMotionValue(percentageStart);
  const roundedValue = useTransform(motionValue, (latest) => Math.round(latest));
  const formattedValue = useMotionTemplate`${roundedValue}%`;

  useEffect(() => {
    const animation = animate(motionValue, isInView ? percentageEnd : percentageStart, {
      delay: isInView ? animationDelay : 0,
      duration: isInView ? animationDuration : 0.05,
    });

    return animation.stop;
  }, [motionValue, isInView, animationDuration, animationDelay]);

  return (
    <ChakraText color="#3B864D" fontSize="10px">
      {formattedValue}
    </ChakraText>
  );
}
